import type { FC, ReactNode } from 'react'

import { Skeleton } from '@/components/ui/feedback'

// Shown for a moment on a full page load while the address bar filters are read
export const PageSkeleton: FC = (): ReactNode => {
    return (
        <div className='space-y-6' aria-busy='true' aria-label='Memuat halaman'>
            <div className='space-y-3'>
                <Skeleton className='h-3 w-28' />
                <Skeleton className='h-8 w-72 max-w-full' />
                <Skeleton className='h-4 w-[28rem] max-w-full' />
            </div>

            <Skeleton className='h-24 w-full rounded-xl' />
            <Skeleton className='h-80 w-full rounded-xl' />
        </div>
    )
}
